var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field",class:{vertical: _vm.orientation === 'vertical'}},[_c('p',{on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"switch",staticClass:"switchButton",class:{enabled: _vm.enable},on:{"click":_vm.toggle}},[_c('div',{ref:"button",class:`button ${_vm.enable ? 'enable' : ''}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }